.error {
	color: var(--lp-color-text-feedback-error);
	font: var(--lp-text-body-2-regular);
}
